module.exports = "<svg viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\"><g transform=\"translate(1 1)\" fill=\"none\" fill-rule=\"evenodd\"><circle stroke=\"#7290CB\" fill=\"#FFF\" cx=\"10\" cy=\"10\" r=\"10\"></circle><circle fill=\"#7290CB\" cx=\"10\" cy=\"10\" r=\"7\"></circle></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/RadioControl/radiobtn_on.svg
// module id = 2037
// module chunks = 0